module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("“It’s not the rape that distresses me so much,” Madame Simone said to me. Her eyes were green, the shade of spring leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She was a professional girl. She knew men. She had been there, if you see what I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t feel easy here in the parlor of what an old-timer, being polite, would have called a sporting house. The room was all right—all right, that is, if you could accept upholstery of blushing pink and pink lampshades, an oversized, gilt-edged mirror on one wall and, beside it, a sideboard with an array of bottles. No girls waited in line. No one tried to hustle me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was still rape,” I said. “A violation of person, and that’s a serious crime.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But to kill her! That gets me. Why did he have to do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was dressed in a summer suit, cream-colored, with flecks of pink in it and might have just prepared for a visitor or for shopping or for a business session. I could see her sitting in a meeting of some board of directors. Not the ordinary madam, I thought, but a madam all the same no matter how she spelled it. The Simone must have been an invention.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seated in the chair she had assigned me, I said, “God knows why he killed her, but rape and murder sometimes go together.” My eyes went to a polished wooden stairway, but no one was coming down it. “Now the victim, this Laura Jane Smitson, tell me about her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve answered the questions once, to a big, dumb deputy who came here before you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I knew she referred to Halvor Amussen, who was big and brave but heavy-handed and hardly brilliant. I had studied his notes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He may have missed something, or you overlooked something. Now about the girl?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cradled phone at her side rang, and she answered, “Yes, Mr.—” Her gaze came to me. “I have arranged everything as you wished. See you then. Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The girl?” I prompted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She worked for the Overthrust Oil Company. A stenographer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She didn’t live here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, no. I almost never have resident girls. She lived with her parents.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Any residents here now?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No again. I believe you are thinking of the old-fashioned whorehouse. Mine are respectable town girls. Most of them work during the day. I keep a list. We have nothing in common with those old houses.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nothing, I thought, but the commodity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The time was midafternoon. Through a window at the side of the room I could see down a slope to the bridge over Muddy Creek. The creek was the dividing line between the two counties. The body of the girl had been found by two youngsters who were playing on the other side of the bridge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have a good list,” Madame Simone went on. “The pill has opened opportunities for the working girl. She adds to her income, and the men get what they want. Everyone’s satisfied. A first-class arrangement. Right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had never encountered such matter-of-fact cynicism. Instead of answering, I asked, “Did the girl have regular customers? Was she somebody’s favorite?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s confidential. I’m a clam.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can have you subpoenaed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She gave me a half-smile. “I doubt you’d want to do that. All the broken homes, the divorces, wives mad as hornets. Right in your town, too. Think of the ruined reputations.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about her immediate bosses? Were they her customers?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Clients, we call them. I’ll answer that question, and the answer is no.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The telephone rang again. She said into it, “Yes, of course. I’ll see. Could you call me back later?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You want to find the murderer, don’t you?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s a foolish question. Of course I do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then you might help by telling me the names of her clients.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Doctors have a right to confidential relationships. So do lawyers. I claim my right. What’s more, the names wouldn’t help you at all. I’m positive of that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not being cooperative. Don’t you care?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why do you think I’m talking to you? Of course I care. You don’t know when a person’s hurting.” She flung out a hand. “So I talk to you. Talk is like a bandage over a sore. This give-and-take hides the wound.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I thought she might be going to cry, but she straightened her face and asked, “Want a drink? On the house?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The phone rang again. She let it ring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I said, “No, thanks.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She gestured toward the sideboard and bottles. “I don’t sell drinks. I haven’t a license. The drinks are complimentary. A client may need something to encourage him in the first place and something to buck him up in the second.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again that serene cynicism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So,” I said for lack of something better, “you make the arrangements and provide the house.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re learning.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Another question. Was there any trouble here at the house before she left for home?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What makes you think there was?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m asking.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She nodded slowly. “For reasons—well, because fights are bad for my reputation—I haven’t mentioned it. And your partner, the deputy who was here earlier, didn’t ask. Besides, he rubbed me the wrong way. I don’t like to tell you about it now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It might help.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sat and waited.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was a ruffian.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who was?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t get his name, not then and really not at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe you’ll remember. Go on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was a stranger in dirty clothes and boots, and he was all hair, head and face. Somehow he found his way here. He saw Laura Jane and wanted her. Not just wanted her. Demanded her. You will understand he wasn’t our type. Of course Laura wouldn’t have him. So he began shouting, yelling his money was as good as any man’s and who did we think we were. He grabbed Laura by the arm.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Madame Simone fell silent as if re-living the scene. I didn’t nudge her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I have a man here at night. You’d call him a bouncer. I got him in, and he yanked the man away, and I called my friend, our county sheriff. He’s quick to send me help. So Mugs and the stranger struggled for a while, and finally the man butted Mugs in the belly and hit him on the chin, and that was it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It for Mugs.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. Then the man grabbed Laura Jane again and tried to wrestle her upstairs. Just in time the deputies arrived.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And arrested him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He wanted to fight, but one of them laid a billy alongside his head, and the other drew a gun. That calmed the man down except for his tongue. He was still swearing and yelling he had his rights.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did they get his name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I told you I didn’t get it. Nearest I could come was Ford maybe. What with his mouthing off and Mugs groaning and Laura Jane crying in a corner, it was hard to hear. Being sarcastic, I guess, one of the men called him Mister. Anyhow, that’s what it sounded like.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So they took him in?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No. They gave him a lecture and threw him out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What! No charges?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In my business you can’t afford trials. The publicity is bad. The sheriff knows that. This is an orderly house.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll get the name from his office.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I doubt it. The officers will have thrown away whatever notes they took. There won’t be any report.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’ll remember the name.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If they do, they won’t give it to you. The sheriff doesn’t like outsiders to nose into his business.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rape and murder are everybody’s business.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But a fight in this house isn’t. That’s strictly for the county.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You could ask him to give me the name.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even then, even if one of the officers remembers it, you’ll be turned down. You see, the sheriff prides himself on keeping order in the town and county. He wants it clean, so he says. That includes this house. He won’t let you pry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Could you identify the man we’re talking about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If I had to, I suppose.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How much longer did Laura Jane stay? After the man had been marched out, I mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Quite a while. An hour or more. I tried to keep her here, but she was so upset that nothing would do but to go home. It’s only across the creek and to the right. About a quarter of a mile.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The phone interrupted us again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What time did she leave?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“About eleven o’clock. Time for the stranger to be long gone.” She rose. “Now I’ve told you all I know. What about that drink?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had one with her and said thanks and goodbye.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a8ba322","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter001.vue
// module id = 75
// module chunks = 0